module.exports = __webpack_public_path__ + "static/media/YM80_4.61b119dd.jpg";